<template>
  <div class="app-container">
    <!-- Banner du haut -->
    <TopBanner 
      :emailValidated="emailValidated" 
      @subscribe="goToSuscribe" 
    />

    <!-- Formulaire de connexion -->
    <LoginForm />

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import TopBanner from '@/views/authentification/TopBanner.vue'
import LoginForm from '@/views/authentification/LoginForm.vue'
import AppFooter from '@/views/authentification/AppFooter.vue'

export default {
  name: "Login",
  components: {
    TopBanner,
    LoginForm,
    AppFooter
  },
  data() {
    return {
      emailValidated: false
    }
  },
  methods: {
    goToSuscribe() {
      this.$router.push("/inscription-credits");
    }
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: #f8fafa;
  display: flex;
  flex-direction: column;
}
</style>